import React, { useState } from 'react';
import '../styles/Navbar.css';
import logo from '../img/logo4.png';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="navbar-logo">
          <img src={logo} alt="Keirin logo" className="logo-img" />
        </div>

        <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu} aria-label="Toggle menu">
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <ul className={`nav-menu ${menuOpen ? 'nav-menu-open' : ''}`}>
          <li className="nav-item">
            <a href="#services" className="nav-link" onClick={closeMenu}>Services</a>
          </li>

          <li className="nav-item">
            <a href="#why-keirin" className="nav-link" onClick={closeMenu}>Why Keirin</a>
          </li>

          <li className="nav-item">
            <a href="#industries" className="nav-link" onClick={closeMenu}>Industries</a>
          </li>

          <li className="nav-item">
            <a href="#insights" className="nav-link" onClick={closeMenu}>Insights</a>
          </li>

          <li className="nav-item">
            <a href="#gaming" className="nav-link" onClick={closeMenu}>Gaming</a>
          </li>

          <li className="nav-item">
            <a href="#contact" className="nav-link" onClick={closeMenu}>Contact Us</a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
